

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TheAppBar from '~/components/TheLayout/TheAppBar.vue';
import TheContent from '~/components/TheLayout/TheContent.vue';
import TheLoader from '~/components/TheLayout/TheLoader.vue';
import TheNotifications from '~/components/TheLayout/TheNotifications.vue';
import TheSideMenu from '~/components/TheLayout/TheSideMenu.vue';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import { PopupModule } from '~common-store/modules/popup';

@Component({
    components: {
        TheAppBar,
        TheSideMenu,
        TheContent,
        TheLoader,
        TheNotifications,
    },
})
export default class TheLayout extends Mixins(DarkThemeInfoMixin) {
    @Watch('isDarkModeActive', { immediate: true, deep: true })
    onDarkModeChanged(newValue: boolean) {
        this.$vuetify.theme.dark = newValue;
    }
    get popupRequested() {
        return PopupModule.popupRequested;
    }
    @Watch('popupRequested', { immediate: true })
    hideScrollbarIfPopupIsRequested(val: string) {
        const html =  document.querySelector('html');
        if (html) {
            // if no popup is requested, leave overflow
            // otherwise hide scrollbar
            html.style.overflow = val === '' ? '' : 'hidden';
        }
    }
}
